module.exports = __webpack_public_path__ + "static/media/resturant-menu-theme-3.c8a7e95b.jpg";